import { inject, Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * staticで使いたい
 * WARNING: modalを使う前にinjectする事(app.component推奨)
 */
@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  static modalsService: ModalsService;
  static get ngbModal() { return this.modalsService.$ngbModal; }
  static get injector() { return this.modalsService.$injector; }
  //
  protected $ngbModal = inject(NgbModal);
  protected $injector = inject(Injector);
  constructor() { ModalsService.modalsService = this; }

}
